import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "../../../../shared/loader/Loader";
import './UserActivityHistory.css'
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { SUCCESS } from "../../../../../constants/AppConstants";

const UserActivityHistory = ({ activityHistory, loading, error }) => {
  const { t } = useTranslation(["CSAgenttranslation"]);
  const TABS = {
    'ACTIVITY_HISTORY': 'ACTIVITY_HISTORY'
  }
  const [activeTab, setActiveTab] = useState((activityHistory?.deviceActivityHistory?.length > 0)
    ? activityHistory?.deviceActivityHistory[0].deviceId
    : null);

  useEffect(() => {
    if (activityHistory && activityHistory?.actionStatus?.toUpperCase() === SUCCESS) {
      if ((activityHistory?.deviceActivityHistory?.length > 0)) {
        setActiveTab(activityHistory?.deviceActivityHistory[0]?.deviceId);
      } else {
        setActiveTab(TABS.ACTIVITY_HISTORY);
      }
    }
  }, [TABS.ACTIVITY_HISTORY, activityHistory]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div className="email-log-error">{t("ERROR_MESSAGES.NO_USER_ACTIVITY_HISTORY")}</div>;
  }

  return (
    <div className="mt-40">
      {
        activityHistory && (
          <div className="user-activity-history">
            <div className="tab-btn-wrapper">
              <div>
                <Nav tabs>
                  {(activityHistory?.deviceActivityHistory?.length > 0) ?
                    activityHistory?.deviceActivityHistory.map((history) => (
                      <NavItem>
                        <NavLink active={activeTab === history.deviceId} onClick={() => setActiveTab(history.deviceId)}>
                          {history.serialNumber}
                        </NavLink>
                      </NavItem>
                    )) :
                    <NavItem>
                      <NavLink active={activeTab === TABS.ACTIVITY_HISTORY} onClick={() => setActiveTab(TABS.ACTIVITY_HISTORY)}>
                        {t('CUSTOMER_DASHBOARD.TAB_ITEMS.USER_ACTIVITY_HISTORY')}
                      </NavLink>
                    </NavItem>
                  }
                </Nav>
              </div>
            </div>
            <div className="activity-history-content-wrapper">
              <TabContent activeTab={activeTab}>
                {
                  (activityHistory?.deviceActivityHistory?.length > 0) ?
                    activityHistory?.deviceActivityHistory.map((history) => (
                      <TabPane tabId={history.deviceId}>
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">{t("CUSTOMER_DASHBOARD.USER_ACTIVITY_HISTORY.SERIAL_NUMBER")}</th>
                              <th scope="col">{t("CUSTOMER_DASHBOARD.USER_ACTIVITY_HISTORY.DEVICE_ID")}</th>
                              <th scope="col">{t("CUSTOMER_DASHBOARD.USER_ACTIVITY_HISTORY.CATEGORY")}</th>
                              <th scope="col">{t("CUSTOMER_DASHBOARD.USER_ACTIVITY_HISTORY.DESCRIPTION_ID")}</th>
                              <th scope="col">{t("CUSTOMER_DASHBOARD.USER_ACTIVITY_HISTORY.TARGET")}</th>
                              <th scope="col">{t("CUSTOMER_DASHBOARD.USER_ACTIVITY_HISTORY.TIME")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {history?.activityHistory?.map((activity, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{activity.deviceId}</td>
                                <td>{activity.category}</td>
                                <td>{activity.descriptionId}</td>
                                <td>{activity.target || t("NOT_AVAILABLE")}</td>
                                <td>{new Date(activity.time).toLocaleString()}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </TabPane>
                    )) :
                    <TabPane tabId={TABS.ACTIVITY_HISTORY}>
                      <div className="email-log-error">{t("ERROR_CONTENT.USER_ACTIVITY_HISTORY")}</div>
                    </TabPane>
                }
              </TabContent>
            </div>
          </div>
        )
      }
    </div>
  )
};
export default UserActivityHistory;
